<div class="container mt-5 mb-5">
  <div class="row">
    <div class="col-lg-12">
      <simple-html [html]="text"></simple-html>
    </div>
  </div>
</div>
<!-- <iframe src="http://hml.agilb2b.com.br/custom/1/" width="100%"[height]="height" style="border: none;"></iframe> -->
<!-- <div [innerHTML]="pageContent"></div> -->
